import './Form.css';
import FormHeader from './FormHeader';
import FormSubmit from './FormSubmit';
import FormContent from './FormContent';
import Model from './Model';
import React, { useState, useEffect } from 'react';

function Form() {

  const model = Model();

  model.fields.forEach( field => {

    if (field.validate){
      useEffect(() => {
        let error = field.validate(field.property[0]);
        field.error[1](error);
      },[field.property[0]]);
    }
  });

  const valid = useState(false);
  const displayErrors = useState(false);

  useEffect(() => {
    valid[1](model.fields.map((field) => {return field.error[0]}).every(e => e === null));
  }, model.fields.map((field) => {return field.error[0]}));

  const handleSubmit = (evt) => {
    evt.preventDefault();
    if (valid[0]) {
      window.top.location.href = `https://u1widh2lx8.execute-api.us-east-1.amazonaws.com/OnboardToSoftwareAcademy?firstName=${model.fields[0].property[0]}&lastName=${model.fields[1].property[0]}&email=${model.fields[2].property[0]}`;
    } else {
      displayErrors[1](true);
    }
  }

  return (
    <React.Fragment>
      <FormHeader />
      <div className="auth-content">
        <div className="auth-content-inner">
          <div className="registration">
            <form onSubmit={handleSubmit} slot="content" className="o-form o-form-edit-mode" spellCheck="false">
              <div className="o-form-content o-form-theme clearfix">
                <h2 className="okta-form-title o-form-head">Register for HCLSoftware U</h2>
                <div className="o-form-fieldset-container">
                  <FormContent model={model} displayErrors={displayErrors[0]}/>
                  <span className="required-fields-label">* indicates required field</span>
                </div>
              </div>
              <FormSubmit valid={valid[0]}/>
            </form>
            <div className="auth-footer">
              {/* <span><a target="_top" href="https://id.hcltechsw.com/home/hclcust_hclsoftwareacademy_1/0oa9ckw0tzad7Op3I357/aln9cldec0Z9zpcQF357" className="registration-link">Existing Academy User? Login</a></span> */}
              <span><a target="_top" href="https://id.hcltechsw.com/home/hclcust_hclsoftwareuniversity_1/0oaq3xlmdqTa0o2dJ357/alnq3xr0qsyPhnmfb357" className="registration-link">Existing User? Login</a></span>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default Form;
